import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map } from 'rxjs/operators';
import { BackendService } from 'src/app/core/backend.service';
import * as UserActions from './actions';

@Injectable()
export class UserEffects {

  constructor(
    private actions$: Actions,
    private backend: BackendService
  ) { }

  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.LoadUser),
      exhaustMap(() =>
        this.backend.getUser().pipe(
          map(user => UserActions.SetUser({ user }))
        )
      )
    )
  )
}
